import { render, staticRenderFns } from "./index_RC.vue?vue&type=template&id=65ef1b73&scoped=true"
import script from "./index_RC.vue?vue&type=script&lang=js"
export * from "./index_RC.vue?vue&type=script&lang=js"
import style0 from "./index_RC.vue?vue&type=style&index=0&id=65ef1b73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef1b73",
  null
  
)

export default component.exports